<template>
  <modal
    name="modal-notify-matching"
    height="auto"
    width="20%"
    class="customSurveyModal"
    :scrollable="true"
    @closed="closed"
  >
    <div class="row7">
      <header class="modalHeader flex flexAlignS">
        <div class="title">
          <p>알림</p>
        </div>
        <button class="common-modal__close" @click="closed"></button>
      </header>
    </div>
    <div class="textareaContainer">
      Request Matching has been
      {{ rejectNoties[0].status.toString().toLowercase() }}
    </div>
    <div class="modalFooterBtn btnBox" v-if="rejectNoties.length > 0">
      <button class="redborderBtn" @click="gotoPage">확인하러가기</button>
      <button class="redBtn" @click="closed">취소</button>
    </div>
  </modal>
</template>

<script>
import { ROLE } from "@/data/role";
import { mapState } from "vuex";

export default {
  name: "ModalNotifyMatching",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState("auth", ["user", "rejectNoties"]),
  },
  methods: {
    closed() {
      this.$modal.hide("modal-notify-matching");
    },

    gotoPage() {
      this.closed();
      let path = "";
      if (this.user.roleName == ROLE.CORP) {
        path = "/corp/myMatching";
      } else {
        path = "/user/myMatching";
      }

      this.$router.push({
        path,
        query: {
          requestIdx: this.rejectNoties[0].idx,
          stauts: this.rejectNoties[0].status,
        },
      });
    },

    onClickCancel() {
      this.hide();
    },
  },
};
</script>
<style scoped>
.customSurveyModal header button {
  padding: 0 0rem;
  width: 20px;
  height: 20px;
  background-image: url("~@/assets/images/icons/close.svg");
}
.textareaContainer {
  width: 100%;
  text-align: center;
  font-size: 2.4rem;
  font-weight: 500;
  padding: 0 4rem 2rem 4rem;
}
.textareaContainer textarea {
  width: 90%;
  text-align: center;
  font-size: 2.4rem;
  resize: none;
}
</style>
